import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './styles/global.css';

const updateServiceWorker = registerSW({
  onNeedRefresh() {
    if (window.confirm('A new RealImager version is ready. Update now?')) void updateServiceWorker(true);
  }
});

createRoot(document.getElementById('root')!).render(
  <App />
);
